<template>
  <div class="dashboard background">
    <toast />
    <dashboard-page pcontent="1" page="COURSES">
      <!-- course manager  -->
      <card w='80%' minWidth='1050px' v-if='true'>
        <!-- card header -->
        <div class='fRow fullWidth jStart aCenter'>
          <div class='growFull fCol jStart aStart'>
            <h3 class='growFull text-right'>مدیریت بازی</h3>
            <p class='note'>مدیریت بازی ریمیک</p>
          </div>
          <btn isMini='true' label='به‌روز رسانی' bc='#667089'
            style="margin: 8px !important;"
            v-if="false"
            icon='keyboard_arrow_left' @click.native="backToCourse"/>
        </div>
        <div class="tabHeader fRow jStart aCenter fullWidth" id="tab">
          <a @click="toggleSection('category')"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: section === 'category'}">
            <i class="material-icons-round transition-fast">table_rows</i>
            <span class="transition-fast">دسته‌بندی بازی مرحله‌ای</span>
          </a>
          <a @click="toggleSection('leveledGame')"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: section === 'leveledGame'}">
            <i class="material-icons-round transition-fast">stairs</i>
            <span class="transition-fast">بازی‌های مرحله‌ای</span>
          </a>
          <a @click="toggleSection('instantGame')"
            v-if="false"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: section === 'instantGame'}">
            <i class="material-icons-round transition-fast">dashboard</i>
            <span class="transition-fast">بازی‌های تصادفی</span>
          </a>
          <a @click="toggleSection('groupGame')"
            v-if="false"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: section === 'groupGame'}">
            <i class="material-icons-round transition-fast">groups</i>
            <span class="transition-fast">بازی‌های گروهی</span>
          </a>
          <a @click="toggleSection('bankCategory')"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: section === 'bankCategory'}">
            <i class="material-icons-round transition-fast">dynamic_form</i>
            <span class="transition-fast">دسته‌بندی سؤالات</span>
          </a>
          <a @click="toggleSection('bank')"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: section === 'bank'}">
            <i class="material-icons-round transition-fast">quiz</i>
            <span class="transition-fast">بانک سؤالات</span>
          </a>
          <a @click="toggleSection('message')"
            class="tabBtn fRow jCenter aCenter
            transition-fast" v-bind:class="{selected: section === 'message'}">
            <i class="material-icons-round transition-fast">chat</i>
            <span class="transition-fast">پنل ارسال پیام</span>
          </a>
        </div>
        <!-- █دسته بندی بازی های مرحله ای█ -->
        <div class="examsList fRow jStart aCenter fullWidth wrap"
          v-if="section === 'category'" id="uploaders">
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3>دسته‌بندی بازی مرحله‌ای</h3>
            <div class="ruleBox fCol jStart aStart fullWidth">
              <h4>دسته‌بندی بازی‌های مرحله‌ای را ایجاد، ویرایش و حذف کنید</h4>
            </div>
          </div>
          <!-- اضافه کردن دسته‌بندی -->
          <div class="fullWidth fCol jStart aStart inputHolder addBox"
            ref="top"
            style="margin-top: 24px;">
            <h2 class="fRow jStart aCenter">
              <i class="material-icons-round">add</i>
              ایجاد دسته‌بندی‌ جدید</h2>
            <div class="fRow jBetween aCenter fullWidth">
              <div class="growFull fRow jBetween aCenter inputHolder">
                <div class="w50 fCol jCenter aStart inputWraper">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: fieldErr}">category</i>
                    نام دسته‌بندی</span>
                  <input class="transition-fast f fullWidth"
                    placeholder="نام دسته‌بندی"
                    type="text" v-model="categoryName"/>
                </div>
                <div class="w25 fCol jStart aStart">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: fieldErr}">category</i>
                    انتخاب رشته</span>
                    <cool-select
                      class="fullWidth"
                      @select="selected($event, 'field')"
                      v-model="field"
                      disable-search
                      :items="fields"
                      :item-value="fields.id"
                      :item-text="fields.title">
                      <!-- slot for each item in the menu -->
                      <template slot="item" slot-scope="{ item: fields }">
                        <div style="display: flex; align-items: center;">
                          <div>
                            {{ fields.title }}
                          </div>
                        </div>
                      </template>
                      <!-- slot for the selected item (in the text field) -->
                      <template slot="selection" slot-scope="{ item: fields }">
                        <div>
                          {{ fields.title }}
                        </div>
                      </template>
                    </cool-select>
                </div>
                <div class="w25 fCol jStart aStart inputHolder">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: gradeErr}">category</i>
                    انتخاب پایه‌ی تحصیلی</span>
                    <cool-select
                      class="fullWidth"
                      @select="selected($event, 'grade')"
                      v-model="grade"
                      disable-search
                      :items="grades"
                      :item-value="grades.id"
                      :item-text="grades.title">
                      <!-- slot for each item in the menu -->
                      <template slot="item" slot-scope="{ item: grades }">
                        <div style="display: flex; align-items: center;">
                          <div>
                            {{ grades.title }}
                          </div>
                        </div>
                      </template>
                      <!-- slot for the selected item (in the text grade) -->
                      <template slot="selection" slot-scope="{ item: grades }">
                        <div>
                          {{ grades.title }}
                        </div>
                      </template>
                    </cool-select>
                </div>
              </div>
              <switch-button
                activeLabel="فعال"
                deactiveLabel="غیرفعال"
                style="margin: 0 16px"
                @click.native="categoryStatus = !categoryStatus"
                :val="categoryStatus" />
              <div class="b fRow jStart aCenter"
                @click="console.log('create new category')"
                v-bind:class="{active: categoryName.length > 0}">
                <i class="material-icons-round">add</i>
                <label>اضافه کردن دسته‌بندی</label>
              </div>
            </div>
          </div>
          <div class='gridHead gridRow fRow jBetween fullWidth'>
            <div class='tableHead growFull'>دسته</div>
            <!-- <div class='tableHead itemImg'>تصویر</div> -->
            <div class='tableHead state'>وضعیت</div>
            <div class='tableHead actions'>عملیات</div>
          </div>
          <div class="fCol jCenter aCenter selectField fullWidth"
            v-if="true">
            <i class="material-icons-round">info</i>
            <span>لطفا صبر کنید</span>
          </div>
          <!-- list -->
          <div class="fullWidth fCol aCenter jBetween results" v-if="loaded">
            <div v-for="(item, index) in categories" v-bind:key="index"
              class="fullWidth fRow jBetween aCenter fieldRow transition-fast"
                v-bind:class="{editMode: categoryEditIndex === index,
                deleteMode: categoryDeleteIndex === index}">
              <div class="fieldName growFull">
                <input type="text"
                  class="fullWidth transition-fast"
                  v-model="categories[index].title"
                  @keyup.enter="saveEdits(index)"
                  :id="`item${index}`"
                  :disabled="index !== categoryEditIndex" />
              </div>
              <div class="fieldStatus state fRow jCenter aCenter">
                <switch-button
                  activeLabel="فعال"
                  deactiveLabel="غیرفعال"
                  @click.native="changeStatus(index)"
                  :val="item.status" />
              </div>
              <div class="actions fRow jCenter aCenter">
                <!-- ویرایش -->
                <i class="material-icons-round"
                  v-if="categoryEditIndex !== index"
                  @click="edit(index)">edit</i>
                <!-- حذف -->
                <i class="material-icons-round"
                  @click="deleteItem(index)"
                  v-if="editIndex !== index">delete</i>
                <!-- کنسل کردن ویرایش -->
                <i class="material-icons-round"
                  v-if="categoryEditIndex === index"
                  @click="discardEdits(index)">close</i>
                <!-- ذخیره -->
                <i class="material-icons-round save"
                  v-if="categoryEditIndex === index"
                  @click="saveEdits(index)">save</i>
              </div>
              <div class="deleteDialoge fRow jStart aCenter"
                v-if="categoryDeleteIndex === index">
                <span>آیا از حذف رشتۀ {{item.title}} مطمئنید؟</span>
                <div class="textBtn fRow jStart aCenter"
                  @click="deleteField(index)">
                  <i class="material-icons-round">delete_sweep</i>
                  <label>بله حذف شود</label>
                </div>
                <div class="textBtnFlat fRow jStart aCenter"
                  @click="categoryDeleteIndex = -1">
                  <i class="material-icons-round">close</i>
                  <label>خیر، انصراف</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- █ بازی های مرحله ای █ -->
        <div class="examsList fRow jBetween aStart fullWidth wrap"
          id='list' v-if="section === 'leveledGame'">
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3>مشاهده، ویرایش و حذف بازی‌های مرحله‌ای</h3>
            <div class="ruleBox fCol jStart aStart fullWidth">
              <h4>ابتدا سؤالات مربوط به هر بازی را در بانک سؤال ثبت کنید، سپس
                دسته بندی سؤالات مربوط به هر بازی را وارد کنید.
              </h4>
              <h4>برای ویرایش سؤالات هر بازی بانک سؤال را ویرایش کنید.
              </h4>
            </div>
          </div>
          <!-- اضافه کردن بازی مرحله ای -->
          <div class="fRow jStart aCenter fullWidth wrap">
            <div class="inputHolder fullWidth fRow jStart aCenter">
              <div class="growFull fCol jStart aStart inputHolder" style="margin-bottom: 0">
                <span class="fRow jStart aCenter">
                  عنوان بازی</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input class="transition-fast"
                    placeholder="عنوان بازی"
                    type="text">
                </div>
              </div>
              <div class="ih w25 fCol jStart aStart" style="margin: 0 8px;">
                <span>انتخاب طبقه‌بندی</span>
                <cool-select
                  class="fullWidth"
                  @select="selected($event, 'field')"
                  v-model="newGameClassification"
                  disable-search
                  :items="classifications"
                  :item-value="classifications.id"
                  :item-text="classifications.title">
                  <!-- slot for each item in the menu -->
                  <template slot="item" slot-scope="{ item: field }">
                    <div style="display: flex; align-items: center;">
                      <div>
                        {{ field.title }}
                      </div>
                    </div>
                  </template>
                  <!-- slot for the selected item (in the text field) -->
                  <template slot="selection" slot-scope="{ item: field }">
                    <div>
                      {{ field.title }}
                    </div>
                  </template>
                </cool-select>
              </div>
              <div class="b fRow jStart aCenter" style="margin-top: 16px"
                v-bind:class="{active: subCatErr}">
                <i class="material-icons-round">done_all</i>
                <label>اضافه کردن بازی مرحله‌ای</label>
              </div>
            </div>
            <game-level-row
              v-for="(item, index) in gameLevelArray"
              v-bind:key="index"
              :data="item"
              :indx="index"/>
          </div>
        </div>
        <!-- █ گروه ها █ -->
        <div class="examsList fRow jStart aCenter fullWidth wrap"
          v-if="section === 'groupGame'" id="uploaders">
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3>مدیریت گروه‌ها</h3>
            <div class="ruleBox fCol jStart aStart fullWidth">
              <h4>گروه و اعضای گروه را مشاهده کنید و در صورت نیاز فعال / غیرفعال کنید</h4>
            </div>
          </div>
          <!-- اضافه کردن بازی مرحله ای -->
          <div class="fRow jStart aCenter fullWidth wrap">
            <div class="inputHolder fullWidth fRow jStart aCenter">
              <div class="growFull fCol jStart aStart inputHolder" style="margin-bottom: 0">
                <span class="fRow jStart aCenter">
                  عنوان گروه</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input class="transition-fast"
                    placeholder="عنوان گروه را جستجو کنید..."
                    type="number">
                </div>
              </div>
              <div class="ih w33 fCol jStart aStart" style="margin: 0 8px;">
                <span>مرتب سازی</span>
                <cool-select
                  class="fullWidth"
                  @select="selected($event, 'field')"
                  v-model="newGameClassification"
                  disable-search
                  :items="groupSort"
                  :item-value="groupSort.id"
                  :item-text="groupSort.title">
                  <!-- slot for each item in the menu -->
                  <template slot="item" slot-scope="{ item: field }">
                    <div style="display: flex; align-items: center;">
                      <div>
                        {{ field.title }}
                      </div>
                    </div>
                  </template>
                  <!-- slot for the selected item (in the text field) -->
                  <template slot="selection" slot-scope="{ item: field }">
                    <div>
                      {{ field.title }}
                    </div>
                  </template>
                </cool-select>
              </div>
              <div class="b fRow jStart aCenter active" style="margin-top: 16px"
                v-bind:class="{active: subCatErr}">
                <i class="material-icons-round">search</i>
                <label>جستجوی گروه‌ها</label>
              </div>
            </div>
            <game-group-row
              v-for="(item, index) in gameGroupArray"
              v-bind:key="index"
              :data="item"
              :indx="index"/>
          </div>
        </div>
        <!-- █ بازی های تصادفی █ -->
        <div class="examsList fRow jBetween aStart fullWidth wrap ltr"
          id='list' v-if="section === 'instantGame'">
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3>مشاهده، ویرایش و حذف بازی‌های ثبت شده</h3>
            <div class="ruleBox fCol jStart aStart fullWidth">
              <h4>بازی‌های ثبت شده را مشاهده و ویرایش کنید</h4>
            </div>
          </div>
          <!-- اضافه کردن بازی -->
          <div class="fRow jStart aCenter fullWidth wrap">
            <div class="inputHolder fullWidth fRow jStart aCenter">
              <div class="growFull fCol jStart aStart inputHolder" style="margin-bottom: 0">
                <span class="fRow jStart aCenter">
                  عنوان بازی</span>
                <div class="fRow jStart aCenter fullWidth inputWraper">
                  <input class="transition-fast"
                    placeholder="عنوان بازی"
                    type="number">
                </div>
              </div>
              <div class="ih w33 fCol jStart aStart" style="margin: 0 8px;">
                <span>انتخاب طبقه‌بندی</span>
                <cool-select
                  class="fullWidth"
                  @select="selected($event, 'field')"
                  v-model="newGameClassification"
                  disable-search
                  :items="classifications"
                  :item-value="classifications.id"
                  :item-text="classifications.title">
                  <!-- slot for each item in the menu -->
                  <template slot="item" slot-scope="{ item: field }">
                    <div style="display: flex; align-items: center;">
                      <div>
                        {{ field.title }}
                      </div>
                    </div>
                  </template>
                  <!-- slot for the selected item (in the text field) -->
                  <template slot="selection" slot-scope="{ item: field }">
                    <div>
                      {{ field.title }}
                    </div>
                  </template>
                </cool-select>
              </div>
              <div class="ih w20 fCol jStart aStart" style="margin: 0 0 0 8px;">
                <span>انتخاب درس</span>
                <cool-select
                  class="fullWidth"
                  @select="selected($event, 'field')"
                  v-model="newGameLesson"
                  disable-search
                  :items="gameLessons"
                  :item-value="gameLessons.id"
                  :item-text="gameLessons.title">
                  <!-- slot for each item in the menu -->
                  <template slot="item" slot-scope="{ item: field }">
                    <div style="display: flex; align-items: center;">
                      <div>
                        {{ field.title }}
                      </div>
                    </div>
                  </template>
                  <!-- slot for the selected item (in the text field) -->
                  <template slot="selection" slot-scope="{ item: field }">
                    <div>
                      {{ field.title }}
                    </div>
                  </template>
                </cool-select>
              </div>
              <div class="b fRow jStart aCenter" style="margin-top: 16px"
                v-bind:class="{active: subCatErr}">
                <i class="material-icons-round">done_all</i>
                <label>اضافه کردن بازی</label>
              </div>
            </div>
            <game-row
              v-for="(item, index) in gameCatsArray"
              v-bind:key="index"
              :data="item"
              :indx="index"/>
          </div>
        </div>
        <!-- █دسته بندی بانک سؤالات بازی -->
        <div class="examsList fRow jStart aCenter fullWidth wrap"
          v-if="section === 'bankCategory'" id="uploaders">
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3>دسته‌بندی بانک سؤالات بازی</h3>
            <div class="ruleBox fCol jStart aStart fullWidth">
              <h4>دسته‌بندی بانک سؤالات بازی را ایجاد، ویرایش و حذف کنید</h4>
            </div>
          </div>
          <!-- اضافه کردن دسته‌بندی -->
          <div class="fullWidth fCol jStart aStart inputHolder addBox"
            ref="top"
            style="margin-top: 24px;">
            <h2 class="fRow jStart aCenter">
              <i class="material-icons-round">add</i>
              ایجاد دسته‌بندی‌ جدید</h2>
            <div class="fRow jBetween aCenter fullWidth">
              <div class="growFull fRow jBetween aCenter inputHolder">
                <div class="fullWidth fCol jCenter aStart inputWraper">
                  <span class="fRow jStart aCenter">
                    <i class="material-icons-round"
                      v-bind:class="{inpErr: fieldErr}">category</i>
                    نام دسته‌بندی</span>
                  <input class="transition-fast f fullWidth"
                    placeholder="نام دسته‌بندی"
                    type="text" v-model="categoryName"/>
                </div>
              </div>
              <switch-button
                activeLabel="فعال"
                deactiveLabel="غیرفعال"
                style="margin: 0 16px"
                @click.native="categoryStatus = !categoryStatus"
                :val="categoryStatus" />
              <div class="b fRow jStart aCenter"
                @click="console.log('create new category')"
                v-bind:class="{active: categoryName.length > 0}">
                <i class="material-icons-round">add</i>
                <label>اضافه کردن دسته‌بندی</label>
              </div>
            </div>
          </div>
          <div class='gridHead gridRow fRow jBetween fullWidth'>
            <div class='tableHead growFull'>دسته</div>
            <!-- <div class='tableHead itemImg'>تصویر</div> -->
            <div class='tableHead state'>وضعیت</div>
            <div class='tableHead actions'>عملیات</div>
          </div>
          <div class="fCol jCenter aCenter selectField fullWidth"
            v-if="true">
            <i class="material-icons-round">info</i>
            <span>لطفا صبر کنید</span>
          </div>
          <!-- list -->
          <div class="fullWidth fCol aCenter jBetween results" v-if="loaded">
            <div v-for="(item, index) in categories" v-bind:key="index"
              class="fullWidth fRow jBetween aCenter fieldRow transition-fast"
                v-bind:class="{editMode: categoryEditIndex === index,
                deleteMode: categoryDeleteIndex === index}">
              <div class="fieldName growFull">
                <input type="text"
                  class="fullWidth transition-fast"
                  v-model="categories[index].title"
                  @keyup.enter="saveEdits(index)"
                  :id="`item${index}`"
                  :disabled="index !== categoryEditIndex" />
              </div>
              <div class="fieldStatus state fRow jCenter aCenter">
                <switch-button
                  activeLabel="فعال"
                  deactiveLabel="غیرفعال"
                  @click.native="changeStatus(index)"
                  :val="item.status" />
              </div>
              <div class="actions fRow jCenter aCenter">
                <!-- ویرایش -->
                <i class="material-icons-round"
                  v-if="categoryEditIndex !== index"
                  @click="edit(index)">edit</i>
                <!-- حذف -->
                <i class="material-icons-round"
                  @click="deleteItem(index)"
                  v-if="editIndex !== index">delete</i>
                <!-- کنسل کردن ویرایش -->
                <i class="material-icons-round"
                  v-if="categoryEditIndex === index"
                  @click="discardEdits(index)">close</i>
                <!-- ذخیره -->
                <i class="material-icons-round save"
                  v-if="categoryEditIndex === index"
                  @click="saveEdits(index)">save</i>
              </div>
              <div class="deleteDialoge fRow jStart aCenter"
                v-if="categoryDeleteIndex === index">
                <span>آیا از حذف رشتۀ {{item.title}} مطمئنید؟</span>
                <div class="textBtn fRow jStart aCenter"
                  @click="deleteField(index)">
                  <i class="material-icons-round">delete_sweep</i>
                  <label>بله حذف شود</label>
                </div>
                <div class="textBtnFlat fRow jStart aCenter"
                  @click="categoryDeleteIndex = -1">
                  <i class="material-icons-round">close</i>
                  <label>خیر، انصراف</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- █ بانک سؤالات █ -->
        <div class="examList fRow jStart aCenter fullWidth" v-if="section === 'bank'">
          <question-bank-manager />
        </div>
        <!-- █ پیام █ -->
        <div class="examsList fRow jBetween aStart fullWidth wrap" v-if="section === 'message'">
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3>ارسال پیام به کاربران بازی</h3>
            <div class="ruleBox fCol jStart aStart fullWidth">
              <h4>ارسال پیام به کاربر، اعضای گروه یا کل کاربران بازی</h4>
            </div>
          </div>
          <div class="fullWidth fRow jBetween aCenter">
            <!-- انتخاب نوع پیام -->
            <div class="inputHolder fullWidth fRow jStart aCenter">
              <div class="fRow jStart aCenter">
                ارسال پیام به
                <div class="radioBtn fRow jStart aCenter transition-fast"
                  v-bind:class="{active: messageMode === 1}"
                  @click="messageMode = 1">
                  <div class="indicator transition-fast">
                    <div class="dot transition-fast"></div>
                  </div>
                  <label class="transition-fast">کاربر</label>
                </div>
                <div class="radioBtn fRow jStart aCenter transition-fast"
                  v-bind:class="{active: messageMode === 2}"
                  @click="messageMode = 2">
                  <div class="indicator transition-fast">
                    <div class="dot transition-fast"></div>
                  </div>
                  <label class="transition-fast">گروه</label>
                </div>
                <div class="radioBtn fRow jStart aCenter transition-fast"
                  v-bind:class="{active: messageMode === 3}"
                  @click="messageMode = 3">
                  <div class="indicator transition-fast">
                    <div class="dot transition-fast"></div>
                  </div>
                  <label class="transition-fast">همه</label>
                </div>
              </div>
            </div>
          </div>
          <div class="fullWidth fCol jStart aStart">
            <div class="ih w33 fCol jStart aStart" style="margin: 0 8px;"
              v-if="messageMode === 2">
              <span>انتخاب گروه</span>
              <cool-select
                class="fullWidth"
                @select="selected($event, 'field')"
                v-model="newGameClassification"
                :items="groupsList"
                :item-value="groupsList.id"
                :item-text="groupsList.title">
                <!-- slot for each item in the menu -->
                <template slot="item" slot-scope="{ item: field }">
                  <div style="display: flex; align-items: center;">
                    <div>
                      {{ field.title }}
                    </div>
                  </div>
                </template>
                <!-- slot for the selected item (in the text field) -->
                <template slot="selection" slot-scope="{ item: field }">
                  <div>
                    {{ field.title }}
                  </div>
                </template>
              </cool-select>
            </div>
            <div class="ih w33 fCol jStart aStart" style="margin: 0 8px;"
              v-if="messageMode === 1">
              <span>انتخاب کاربر</span>
              <cool-select
                class="fullWidth"
                @select="selected($event, 'field')"
                v-model="newGameClassification"
                :items="groupsList"
                :item-value="groupsList.id"
                :item-text="groupsList.title">
                <!-- slot for each item in the menu -->
                <template slot="item" slot-scope="{ item: field }">
                  <div style="display: flex; align-items: center;">
                    <div>
                      {{ field.title }}
                    </div>
                  </div>
                </template>
                <!-- slot for the selected item (in the text field) -->
                <template slot="selection" slot-scope="{ item: field }">
                  <div>
                    {{ field.title }}
                  </div>
                </template>
              </cool-select>
            </div>
            <div class="fRow jStart aStart fullWidth">
              <div class="w66 fCol jStart aStart">
                <div class="fullWidth fCol jStart aStart inputHolder" style="margin-bottom: 0">
                  <span class="fRow jStart aCenter">
                    عنوان پیام</span>
                  <div class="fRow jStart aCenter fullWidth inputWraper">
                    <input class="transition-fast"
                      placeholder="عنوان پیام"
                      type="text">
                  </div>
                </div>
                <div class="fullWidth fCol jStart aStart inputHolder" style="margin-bottom: 0">
                  <span class="fRow jStart aCenter">
                    متن پیام</span>
                  <div class="fRow jStart aCenter fullWidth inputWraper">
                    <textarea class="transition-fast" style="height: 240px"
                      placeholder="متن پیام"
                      type="text"></textarea>
                  </div>
                </div>
                <div class="fullWidth fCol jStart aStart inputHolder" style="margin-bottom: 0">
                  <span class="fRow jStart aCenter">
                    لینک (دلخواه)</span>
                  <div class="fRow jStart aCenter fullWidth inputWraper">
                    <input class="transition-fast"
                      placeholder="https://xyz.com"
                      type="text">
                  </div>
                </div>
              </div>
              <div class="w33 fCol jStart aCenter messageCenter">
                <i class="material-icons-round">message</i>
                <h3>ارسال پیام برای کاربران بازی</h3>
                <span>ابتدا گیرندگان پیام را مشخص کنید سپس عنوان، متن و در صورت نیاز
                  لینک را وارد کنید و دکمه‌ی ارسال را بزنید
                </span>
              </div>
            </div>
          </div>
          <div class="fCol jCenter aCenter fullWidth"
            v-if="loading || noContent">
            <p-bar
              :loading="loading"
              :notYet="notYet"
              :noContent="noContent"
              :notFound="notFound"
              :error="error" />
          </div>
        </div>
      </card>
    </dashboard-page>
    <tool-bar/>
    <right-menu/>
    <modal v-if="modalShow">
      <card w="580px">
        <label class="question">با ترک این صفحه آپلودها متوقف می‌شوند.
          آیا مایل به ترک این صفحه هستید؟</label>
        <div class="fullWidth wrap aStart jStart fRow btnRow">
          <btn label="نمایش لیست ویدئوها" btnWidth='236px' bc='#ff0533'
          icon="delete_sweep" @click.native="showListAnyWay"/>
          <keep-alive>
            <btn fabBtn='true' label="بازگشت" btnWidth='auto'
              @click.native="closeModal" bc='#aaaaaa' icon="close"/>
          </keep-alive>
        </div>
      </card>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import RightMenu from '@/components/RightMenu.vue';
import ToolBar from '@/components/ToolBar.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import Card from '@/components/Card.vue';
import Btn from '@/components/Btn.vue';
import SwitchButton from '@/components/SwitchButton.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import Toast from '@/components/Toast.vue';
import ticks from '@/mixins/ticks';
import Modal from '@/components/Modal.vue';
import { CoolSelect } from 'vue-cool-select';
import 'vue-cool-select/dist/themes/material-design-dark.scss';
import '@/assets/new.scss';
import { EventBus } from '@/plugins/event-bus';
import pBar from '@/components/pBar.vue';
import GameRow from '@/components/GameRow.vue';
import GameLevelRow from '@/components/GameLevelRow.vue';
import GameGroupRow from '@/components/GameGroupRow.vue';
import QuestionBankManager from '@/components/QuestionBankGameManager.vue';

export default {
  mixins: [errorHandler, makeToast, ticks],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      isNewExam: false,
      isExamList: false,
      isBank: true,
      isSubcats: false,
      justClassification: false,
      optionalClassification: false,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      // add question form
      isTestQuestion: true,
      question: '',
      questionErr: true,
      questionMedia: '',
      questionMediaInit: '',
      testTrueAnswer: '',
      tTrueAnsErr: true,
      testA: '',
      testAErr: true,
      testAMedia: '',
      testAMediaInit: '',
      testB: '',
      testBErr: true,
      testBMedia: '',
      testBMediaInit: '',
      testC: '',
      testCErr: true,
      testCMedia: '',
      testCMediaInit: '',
      testD: '',
      testDErr: true,
      testDMedia: '',
      testDMediaInit: '',
      questionTypes: [
        'تستی',
        'تشریحی',
      ],
      questionTypeSelected: 'تستی',
      qTypeSelectedErr: false,
      questionLevels: [
        'آسان',
        'متوسط',
        'سخت',
      ],
      qLevel: '',
      qLevelErr: true,
      questionSelectedField: '',
      qSelectedFieldErr: true,
      questionSelectedGrade: '',
      qSelectedGradeId: '',
      qSelectedGradeIdErr: true,
      lessons: [
        'لطفا درس را انتخاب کنید',
      ],
      questionLessonSelected: '',
      qLessonId: '',
      qLessonIdErr: true,
      classifications: [
        'لطفا طبقه بندی را انتخاب کنید',
      ],
      questionClassificationSelected: '',
      qClassificationId: '',
      qClassificationIdErr: true,
      // list
      rangeStart: '',
      rangeEnd: '',
      examTypes: [
        'هماهنگ',
        'غیر هماهنگ',
      ],
      listSearchType: '',
      listSearchField: '',
      listSearchGrade: '',
      // subcats
      subcatName: '',
      // other
      modalShow: false,
      qEditMode: false,
      letEdit: false,
      editQuestionId: '',
      editQuestionType: -1,
      // new for game
      newGameClassification: '',
      gameCatsArray: [
        {
          id: 0,
          name: 'ریاضی و هوش',
          classificationName: 'بازی - ریاضی و هوش',
          classificationId: 100,
          status: true,
        },
        {
          id: 2,
          name: 'املای فارسی',
          classificationName: 'بازی - املای فارسی',
          classificationId: 200,
          status: true,
        },
        {
          id: 3,
          name: 'دین و زندگی',
          classificationName: 'بازی - دین و زندگی',
          classificationId: 300,
          status: false,
        },
        {
          id: 4,
          name: 'معنی شعر',
          classificationName: 'بازی - معنی شعر',
          classificationId: 400,
          status: true,
        },
        {
          id: 5,
          name: 'ترمودینامیک',
          classificationName: 'بازی - ترمودینامیک',
          classificationId: 500,
          status: false,
        },
        {
          id: 6,
          name: 'جدول تناوبی',
          classificationName: 'بازی - جدول تناوبی',
          classificationId: 600,
          status: true,
        },
      ],
      gameLevelArray: [
        {
          id: 0,
          name: 'هندسه',
          classificationName: 'بازی مرحله‌ای - هندسه',
          classificationId: 100,
          status: true,
        },
        {
          id: 2,
          name: 'حسابــان',
          classificationName: 'بازی مرحله‌ای - حسابان',
          classificationId: 200,
          status: true,
        },
        {
          id: 3,
          name: 'فیزیک',
          classificationName: 'بازی مرحله‌ای - فیزیک',
          classificationId: 300,
          status: false,
        },
        {
          id: 4,
          name: 'ریاضی عمومی',
          classificationName: 'بازی مرحله‌ای - ریاضی عمومی',
          classificationId: 400,
          status: true,
        },
        {
          id: 5,
          name: 'دین و زندگی',
          classificationName: 'بازی مرحله‌ای - دین و زندگی',
          classificationId: 500,
          status: false,
        },
        {
          id: 6,
          name: 'ادبیات فارسی',
          classificationName: 'بازی مرحله‌ای - ادبیات فارسی',
          classificationId: 600,
          status: true,
        },
      ],
      gameGroupArray: [
        {
          id: 0,
          name: 'علم و دانش',
          win: 64,
          total: 112,
          score: 5100,
          users: 24,
          status: true,
        },
        {
          id: 1,
          name: 'ادبیات و هنر',
          win: 32,
          total: 79,
          score: 2835,
          users: 12,
          status: true,
        },
        {
          id: 3,
          name: 'دکتر حسابی',
          win: 112,
          total: 182,
          score: 10562,
          users: 35,
          status: true,
        },
      ],
      gameLessons: [
        {
          id: 0,
          label: 'ریاضی',
        },
        {
          id: 1,
          title: 'فیزیک',
        },
        {
          id: 2,
          title: 'شیمی',
        },
        {
          id: 3,
          title: 'زیست شناسی',
        },
        {
          id: 4,
          title: 'ادبیات',
        },
        {
          id: 5,
          title: 'عربی',
        },
        {
          id: 6,
          title: 'دین و زندگی',
        },
        {
          id: 7,
          title: 'جغرافیا',
        },
        {
          id: 8,
          title: 'تاریخ',
        },
        {
          id: 9,
          title: 'فلسفه',
        },
        {
          id: 10,
          title: 'زمین شناسی',
        },
      ],
      groupSort: [
        {
          id: 0,
          label: 'بیشترین امتیاز',
        },
        {
          id: 1,
          title: 'کمترین امتیاز',
        },
        {
          id: 2,
          title: 'بیشترین برد',
        },
        {
          id: 3,
          title: 'کمترین برد',
        },
        {
          id: 4,
          title: 'جدیدترین گروه‌ها',
        },
        {
          id: 5,
          title: 'قدیمی‌ترین گروه‌ها',
        },
        {
          id: 6,
          title: 'بیشترین درصد موفقیت',
        },
        {
          id: 7,
          title: 'کمترین درصد موفقیت',
        },
      ],
      groupsList: [
        {
          id: 0,
          title: 'لیست گروه‌ها',
        },
        {
          id: 1,
          title: 'لیست گروه‌ها',
        },
      ],
      newLevelGameLesson: '',
      newGameLesson: '',
      messageMode: 1,
      section: 'leveledGame',
      fields: [
        {
          id: -1,
          title: 'صبر کنید...',
        },
      ],
      field: '',
      fieldErr: true,
      grades: [
        {
          id: -1,
          title: 'ابتدا رشته را انتخاب کنید',
        },
      ],
      grade: '',
      gradeErr: true,
      // leveled game category datas
      categoryName: '',
      categoryStatus: true,
      categories: [],
      categoryEditIndex: -1,
      categoryDeleteIndex: -1,
      categoryEditTemp: {},
      // bank category datas
      bankCategoryName: '',
      bankCategoryNameErr: true,

    };
  },
  methods: {
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    backToCourse() {
      this.$store.commit('resetCourseObject');
      this.$router.push('/courses');
    },
    closeModal() {
      this.modalShow = false;
    },
    showListAnyWay() {
      this.isVideoUploading = false;
      this.modalShow = false;
      this.toggleSection('list');
    },
    toggleSection(order) {
      this.section = order;
      switch (order) {
        case 'category': {
          this.getFields();
          break;
        }
        case 'list': {
          break;
        }
        case 'bank': {
          break;
        }
        default:
          break;
      }
    },
    clearSelected() {
      this.examQuestions = [];
      EventBus.$emit('clearSelected');
    },
    deleteQuestion(id) {
      if (this.findInArray(id) !== -1) {
        this.examQuestions.splice(this.findInArray(id), 1);
      }
      EventBus.$emit('updateBankSelected', this.examQuestions);
    },
    findInArray(id) {
      let ind = -1;
      for (let i = 0; i < this.examQuestions.length; i += 1) {
        if (this.examQuestions[i].id === id) {
          ind = i;
        }
      }
      return ind;
    },
    getUploaded(e, item) {
      switch (item) {
        case 'question': {
          this.questionMedia = e;
          break;
        }
        case 'A': {
          this.testAMedia = e;
          break;
        }
        case 'B': {
          this.testBMedia = e;
          break;
        }
        case 'C': {
          this.testCMedia = e;
          break;
        }
        case 'D': {
          this.testDMedia = e;
          break;
        }
        default:
          break;
      }
    },
    // dynamic fields
    getFields() {
      this.fields = [
        {
          id: -1,
          title: 'کمی صبر کنید',
        },
      ];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Fields`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          if (response.data.data.length === 0) {
            this.fields = [
              {
                id: -1,
                title: 'هیچ رشته‌ای ثبت نشده',
              },
            ];
          } else {
            const arr = response.data.data;
            this.fields = [];
            for (let i = 0; i < arr.length; i += 1) {
              const item = {
                id: arr[i].id,
                title: arr[i].title,
              };
              this.fields.push(item);
            }
            // خالی نیست
          }
        } else {
          this.makeToast('error', 'خطا در دریافت رشته‌ها', 3000);
          this.fields = [
            {
              id: -1,
              title: 'خطا در دریافت رشته‌ها',
            },
          ];
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.fields = [
          {
            id: -1,
            title: this.errorHandler(error),
          },
        ];
      });
    },
    // dynamic grades
    getGrades(f) {
      this.grades = [{
        id: -1,
        title: 'لطفا صبر کنید',
      }];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Grades?fieldId=${f}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.grades = [];
          const arr = response.data.data;
          console.log('getGrades', arr);
          for (let i = 0; i < arr.length; i += 1) {
            this.grades.push({
              id: arr[i].id,
              title: arr[i].title,
            });
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getLesson(f) {
      this.lessons = ['لطفا صبر کنید'];
      let reqUrl = `${this.baseURL}/api/v${this.V}/Lessons`;
      if (f !== 0) {
        reqUrl = `${this.baseURL}/api/v${this.V}/Lessons?gradeId=${f}`;
      }
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.lessons = [];
          const arr = response.data.data;
          for (let i = 0; i < arr.length; i += 1) {
            this.lessons.push({
              id: arr[i].id,
              title: arr[i].title,
            });
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        // console.log(error);
      });
    },
    getClassification() {
      this.setMode('loading');
      this.classifications = [{
        title: 'لطفا صبر کنید',
        id: '',
      }];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Questions/classification`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.classifications = [];
          const arr = response.data.data;
          if (arr.length === 0) {
            if (this.isSubcats) {
              this.setMode('noContent');
            }
            // ریست کردن لیست ها
            this.classifications = [{
              title: 'طبقه‌بندی ثبت نشده',
              id: '',
            }];
          } else {
            for (let i = 0; i < arr.length; i += 1) {
              this.classifications.push({
                id: arr[i].id,
                title: arr[i].name,
              });
            }
            this.setMode('loaded');
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'در صورت درستی اتصال اینترنت، با تیم فنی تماس بگیرید');
      });
    },
    newClassification() {
      if (this.subcatName !== '') {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Questions/classification`;
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            name: this.subcatName,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.getClassification();
            this.makeToast('success', 'طبقه‌بندی با موفقیت ثبت شد', 3000);
            this.subcatName = '';
          } else {
            this.makeToast('error', 'مشکلی پیش آمده، دوباره تلاش کنید', 3000);
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
          this.editMode = false;
          // console.log(error);
        }).catch(() => {
          this.makeToast('error', 'در صورت درستی اتصال به اینترنت، با تیم فنی تماس بگیرید', 3000);
          this.editMode = false;
        });
      } else {
        this.makeToast('error', 'ابتدا نام طبقه بندی را ویرایش کنید', 3000);
      }
    },
    newQuestion() {
      if (this.isAddQuestionReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Questions`;
        let qt = 0;
        let q = [];
        let l = 0;
        switch (this.qLevel) {
          case 'سخت': {
            l = 1;
            break;
          }
          case 'متوسط': {
            l = 2;
            break;
          }
          case 'آسان': {
            l = 3;
            break;
          }
          default:
            break;
        }
        if (this.questionTypeSelected === 'تستی') {
          qt = 1;
          q = [
            {
              text: this.testA,
              media: this.testAMedia,
              correctAnswer: this.testTrueAnswer === 'A',
            },
            {
              text: this.testB,
              media: this.testBMedia,
              correctAnswer: this.testTrueAnswer === 'B',
            },
            {
              text: this.testC,
              media: this.testCMedia,
              correctAnswer: this.testTrueAnswer === 'C',
            },
            {
              text: this.testD,
              media: this.testDMedia,
              correctAnswer: this.testTrueAnswer === 'D',
            },
          ];
        } else {
          qt = 2;
          q = [];
        }
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            classificationId: this.qClassificationId !== '' ? this.qClassificationId : null,
            text: this.question,
            media: this.questionMedia,
            options: q,
            field: this.optionalClassification ? parseInt(this.questionSelectedField.id, 10) : -1,
            gradeId: this.optionalClassification ? this.qSelectedGradeId : null,
            lessonId: this.optionalClassification ? this.qLessonId : null,
            level: l,
            type: qt,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.clearQuestion();
          } else {
            this.responseFalse = true;
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
        });
      }
    },
    editQuestions() {
      if (this.isEditQuestionReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Questions/${this.editQuestionId}`;
        let q = [];
        if (this.editQuestionType) {
          q = [
            {
              text: this.testA,
              media: this.testAMedia,
              correctAnswer: this.testTrueAnswer === 'A',
            },
            {
              text: this.testB,
              media: this.testBMedia,
              correctAnswer: this.testTrueAnswer === 'B',
            },
            {
              text: this.testC,
              media: this.testCMedia,
              correctAnswer: this.testTrueAnswer === 'C',
            },
            {
              text: this.testD,
              media: this.testDMedia,
              correctAnswer: this.testTrueAnswer === 'D',
            },
          ];
        } else {
          q = [];
        }
        axios({
          method: 'put',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            text: this.question,
            media: this.questionMedia,
            options: q,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.clearQuestion();
            this.letEdit = false;
            this.qEditMode = false;
            EventBus.$emit('refreshQuestionBank');
          } else {
            this.responseFalse = true;
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
        });
      }
    },
    clearQuestion() {
      this.question = '';
      this.questionMedia = '';
      this.testTrueAnswer = '';
      this.testA = '';
      this.testAMedia = '';
      this.testB = '';
      this.testBMedia = '';
      this.testC = '';
      this.testCMedia = '';
      this.testD = '';
      this.testDMedia = '';
      this.qEditMode = false;
      this.letEdit = false;
      // this.qLevel = '';
      // this.questionSelectedField = '';
      // this.questionSelectedGrade = '';
      // this.qSelectedGradeId = '';
      // this.questionLessonSelected = '';
      // this.qLessonId = '';
      EventBus.$emit('clearPhoto');
    },
    selected(e, dropDown) {
      switch (dropDown) {
        case 'field': {
          this.getGrades(this.field.id);
          break;
        }
        case 'grade': {
          break;
        }
        default:
          break;
      }
    },
    initEdit(question) {
      this.editQuestionId = question.id;
      this.editQuestionType = question.isTest;
      this.qEditMode = true;
      this.letEdit = false;
      this.question = question.title;
      this.questionMedia = question.img;
      this.getUploaded(this.questionMedia, 'question');
      this.testA = question.options[0].text;
      this.testAMedia = question.options[0].media;
      this.getUploaded(this.testAMedia, 'A');
      this.testB = question.options[1].text;
      this.testBMedia = question.options[1].media;
      this.getUploaded(this.testBMedia, 'B');
      this.testC = question.options[2].text;
      this.testCMedia = question.options[2].media;
      this.getUploaded(this.testCMedia, 'C');
      this.testD = question.options[3].text;
      this.testDMedia = question.options[3].media;
      this.getUploaded(this.testDMedia, 'D');
      // options
      for (let i = 0; i <= 3; i += 1) {
        if (question.options[i].correctAnswer) {
          switch (i) {
            case 0: {
              this.testTrueAnswer = 'A';
              break;
            }
            case 1: {
              this.testTrueAnswer = 'B';
              break;
            }
            case 2: {
              this.testTrueAnswer = 'C';
              break;
            }
            case 3: {
              this.testTrueAnswer = 'D';
              break;
            }
            default:
              break;
          }
        }
      }
    },
    setClassification(jc, oc) {
      this.justClassification = jc;
      this.optionalClassification = oc;
    },
    // leveled game category methods
    edit(index) {
      this.categoryEditTemp = this.categories[index];
      this.categoryEditIndex = index;
      console.log('edit: ', this.categoryEditTemp);
    },
    deleteItem(index) {
      this.categoryDeleteIndex = index;
      console.error(this.categoryDeleteIndex);
    },
  },
  components: {
    RightMenu,
    ToolBar,
    DashboardPage,
    Card,
    Btn,
    SwitchButton,
    Toast,
    Modal,
    CoolSelect,
    pBar,
    GameRow,
    GameLevelRow,
    GameGroupRow,
    QuestionBankManager,
  },
  watch: {
    questionTypeSelected() {
      if (this.questionTypeSelected === 'تستی') {
        this.isTestQuestion = true;
      } else {
        this.isTestQuestion = false;
      }
    },
    questionSelectedField() {
      this.lessons = [];
      this.qLessonIdErr = true;
      if (this.questionSelectedField === '') {
        this.eField = -1;
        this.grades = [];
        this.qSelectedGradeId = '';
        this.qSelectedGradeIdErr = true;
        this.qSelectedFieldErr = true;
      } else {
        switch (this.questionSelectedField) {
          case 'حذف فیلتر': {
            this.eField = -1;
            break;
          }
          case 'متوسطه‌ی اول': {
            this.eField = 0;
            break;
          }
          case 'ریاضی': {
            this.eField = 1;
            break;
          }
          case 'تجربی': {
            this.eField = 2;
            break;
          }
          case 'انسانی': {
            this.eField = 3;
            break;
          }
          case 'فنی': {
            this.eField = 4;
            break;
          }
          case 'هنر': {
            this.eField = 1;
            break;
          }
          case 'زبان': {
            this.eField = 1;
            break;
          }
          default:
            break;
        }
        this.qSelectedFieldErr = false;
      }
    },
    questionSelectedGrade() {
      if (this.questionSelectedGrade === '') {
        this.lessons = [];
      } else {
        switch (this.questionSelectedField) {
          case 'زبان': {
            this.eField = 1;
            break;
          }
          default:
            break;
        }
      }
    },
    qSelectedGradeId() {
      if (this.qSelectedGradeId === '') {
        this.qSelectedGradeIdErr = true;
      } else {
        this.qSelectedGradeIdErr = false;
      }
    },
    qClassificationId() {
      if (this.qClassificationId === '') {
        this.qClassificationIdErr = true;
      } else {
        this.qClassificationIdErr = false;
      }
    },
    question() {
      if (this.question === '') {
        this.questionErr = true;
      } else {
        this.questionErr = false;
      }
    },
    testTrueAnswer() {
      if (this.testTrueAnswer === '') {
        this.tTrueAnsErr = true;
      } else {
        this.tTrueAnsErr = false;
      }
    },
    testA() {
      if (this.questionTypeSelected === 'تستی') {
        if (this.testA === '') {
          this.testAErr = true;
        } else {
          this.testAErr = false;
        }
      } else {
        this.testAErr = false;
      }
    },
    testB() {
      if (this.questionTypeSelected === 'تستی') {
        if (this.testB === '') {
          this.testBErr = true;
        } else {
          this.testBErr = false;
        }
      } else {
        this.testBErr = false;
      }
    },
    testC() {
      if (this.questionTypeSelected === 'تستی') {
        if (this.testC === '') {
          this.testCErr = true;
        } else {
          this.testCErr = false;
        }
      } else {
        this.testCErr = false;
      }
    },
    testD() {
      if (this.questionTypeSelected === 'تستی') {
        if (this.testD === '') {
          this.testDErr = true;
        } else {
          this.testDErr = false;
        }
      } else {
        this.testDErr = false;
      }
    },
    qLevel() {
      if (this.qLevel === '') {
        this.qLevelErr = true;
      } else {
        this.qLevelErr = false;
      }
    },
    qLessonId() {
      if (this.qLessonId === '') {
        this.qLessonIdErr = true;
      } else {
        this.qLessonIdErr = false;
      }
    },
    isSubcats() {
      if (this.isSubcats) {
        this.getClassification();
      }
    },
  },
  computed: {
    isAddQuestionReady() {
      // اینجا باید ببینیم کدوم یکی از دوحالت زیر هستند
      // field
      const justClassification = this.qSelectedFieldErr
        && this.qSelectedGradeIdErr
        && this.qLessonIdErr;
      const optionalClassification = !this.qSelectedFieldErr;
      this.setClassification(justClassification, optionalClassification);
      // console.warn(justClassification);
      // console.warn(optionalClassification);
      // console.warn('---------');
      const isTest = this.questionTypeSelected === 'تستی';
      let isFormValid = false;
      // //////////////////////
      if (isTest) {
        if (justClassification) {
          isFormValid = !this.questionErr
            && !this.tTrueAnsErr
            && (!this.testAErr || this.testAMedia !== '')
            && (!this.testBErr || this.testBMedia !== '')
            && (!this.testCErr || this.testCMedia !== '')
            && (!this.testDErr || this.testDMedia !== '')
            && !this.qTypeSelectedErr
            && !this.qLevelErr
            && !this.qClassificationIdErr;
        } else if (optionalClassification) {
          isFormValid = !this.questionErr
            && !this.tTrueAnsErr
            && (!this.testAErr || this.testAMedia !== '')
            && (!this.testBErr || this.testBMedia !== '')
            && (!this.testCErr || this.testCMedia !== '')
            && (!this.testDErr || this.testDMedia !== '')
            && !this.qTypeSelectedErr
            && !this.qLevelErr
            && !this.qSelectedFieldErr
            && !this.qSelectedGradeIdErr
            && !this.qLessonIdErr;
        }
      } else {
        // eslint-disable-next-line
        if (justClassification) {
          isFormValid = !this.questionErr
            && !this.qTypeSelectedErr
            && !this.qLevelErr
            && !this.qClassificationIdErr;
        } else if (optionalClassification) {
          isFormValid = !this.questionErr
            && !this.qTypeSelectedErr
            && !this.qLevelErr
            && !this.qSelectedFieldErr
            && !this.qSelectedGradeIdErr
            && !this.qLessonIdErr;
        }
      }
      return isFormValid;
    },
    isEditQuestionReady() {
      if (this.questionTypeSelected === 'تستی') {
        // eslint-disable-next-line
        return !this.questionErr && !this.tTrueAnsErr && (!this.testAErr || this.testAMedia !== '') && (!this.testBErr || this.testBMedia !== '') && (!this.testCErr || this.testCMedia !== '') && (!this.testDErr || this.testDMedia !== '');
      }
      // eslint-disable-next-line
      return !this.questionErr;
    },
    subCatErr() {
      return this.subcatName !== '';
    },
  },
  mounted() {
    this.$store.commit('setLoadingOff');
    this.getClassification();
    EventBus.$on('edit', (id) => {
      this.initEdit(id);
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/variables.scss';
.sepline {
  height: 24px;
  margin: 0 4px;
  border-left: dashed 1px rgba($color: #000000, $alpha: 0.25);
}
// new for exam ↓↓↓
.bank, .newExam, .examsList {
  margin-top: 16px;
  .addQuestion {
    padding-left: 16px;
    .isTrueCheckBox {
      width: 24px;
      height: 24px;
      color: gray;
      padding: 8px;
      border-radius: 50%;
      margin-left: 8px;
      border: solid 2px gray;
      border-radius: 4px;
      position: relative;
      cursor: pointer;
      * {
        pointer-events: none;
      }
      .tick {
        position: absolute;
        width: 0px;
        top: 8px;
        left: 8px;
        height: 0px;
        border: solid 4px rgb(223, 223, 223);
        border-top: none;
        border-left: none;
        transform: rotate(45deg);
      }
    }
    .isTrueCheckBox:hover {
      border-color: rgb(30, 63, 30);
    }
    .isTrueCheckBox.selected {
      border-color: rgb(30, 63, 30);
      .tick {
        border-color: green;
        width: 12px;
        top: -8px;
        left: 8px;
        height: 24px;
      }
    }
    .qDetail {
      padding: 8px;
      border-right: solid 2px rgba($color: #000000, $alpha: 0.15);
      h5 {
        font-size: 10px;
        font-weight: 300;
      }
      span.ddd {
        font-size: 14px;
        font-weight: bold;
      }
    }
    .noQ {
      height: 112px;
      padding-right: 16px;
      margin-right: 2px;
      border-right: solid 2px rgba($color: #000000, $alpha: 0.15);
      span {
        font-size: 16px;
        font-weight: 100;
        color: gray;
      }
      span.m {
        font-size: 12px;
        font-weight: 300;
        color: gray;
      }
    }
    ul {
      padding: 0;
      margin: 0;
      max-height: 350px;
      border-radius: 8px;
      border: solid 1px rgba($color: #000000, $alpha: 0.05);
      overflow: hidden auto;
      li {
        list-style-type: none;
        padding: 16px;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.05);
        .qindex {
          width: 24px;
          min-width: 24px;
          font-size: 10px;
          font-weight: 300;
          text-align: right;
        }
        .qQuestion {
          span.q {
            font-size: 13px;
            font-weight: bold;
            text-align: right;
          }
          i {
            margin-left: 8px;
            opacity: 0.5;
            transition: all ease-in-out 0.3s;
          }
          i:hover {
            opacity: 1;
          }
          i.hard {
            color: rgb(206, 0, 0);
          }
          i.normal {
            color: rgb(27, 190, 49);
          }
          i.easy {
            color: rgb(54, 101, 161);
          }
          .qOptions {
            p {
              font-size: 12px;
              text-align: right;
              margin-top: 8px;
              font-weight: bold;
            }
          }
        }
        input[type='number'] {
          width: 80px;
          margin-left: 8px;
        }
      }
      li.selected {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      li:hover {
        background-color: rgba($color: #000000, $alpha: 0.0) !important;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.0);
      }
    }
  }
}
.gridItem {
  height: 64px;
}
textarea.qo {
  min-height: 112px;
  resize: none;
}
.minilist {
  box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.15);
  border-radius: 8px;
  overflow: hidden;
  .heads {
    width: 100%;
    text-align: right;
    padding: 8px;
    word-spacing: -2px;
    font-size: 14px;
    color: rgba($color: white, $alpha: 1.0);
    font-weight: 400;
    background-color: #61187A;
    i {
      margin-left: 8px;
      font-size: 16px;
      color: #f0f0f0;
      padding: 8px;
    }
  }
  ul.minilistUl {
    padding: 0;
    margin: 0;
    overflow: hidden auto;
    li {
      width: 100%;
      padding: 12px;
      list-style: none;
      text-align: right;
      border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.15);
      span {
        width: 16px;
        font-size: 10px;
        font-weight: 200;
        text-align: right;
      }
      .title {
        font-size: 14px;
        font-weight: bold;
      }
      .desc {
        font-size: 10px;
        font-weight: 300;
      }
      input.editableItem {
        font-size: 14px;
        padding: 8px 0;
        border: none !important;
      }
      input.editableItem:focus {
        border-width: 0 0 1px 0;
        border-bottom: solid 1px rgba($color: #000000, $alpha: 0.15);
      }
    }
  }
}
// new for exam ↑↑↑
.counter{
  min-width: 96px;
  label{
    font-weight: bold;
    margin-right: 8px;
    font-size: 32px;
    color: rgba($color: #363636, $alpha: 1.0);
  }
  span{
    font-weight: 100;
    font-size: 12px;
    color: rgba($color: #363636, $alpha: 1.0);
  }
}
.courseInfoHolder {
  $iw: 204px;
  padding: 24px;
  margin-bottom: 24px;
  border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.2);
  img.c{
    width: $iw;
    height: $iw;
    border-radius: 8px;
  }
  .courseTeacher{
    font-size: 16px;
    word-spacing: -2px;
    font-weight: 400;
  }
  .courseLesson{
    font-size: 13px;
    word-spacing: 0px;
    font-weight: 400;
  }
  .courseName{
    font-size: 28px;
    word-spacing: -2px;
    font-weight: 400;
    color: #61187A;
    text-align: right;
    line-height: 1.3;
    border-right: solid 4px rgba($color: #61187A, $alpha: 1);
    padding: 0px 8px 0 0;
  }
}

.infos{
  padding: 0 24px;
}
.courseId{
  padding: 2px 8px;
  font-size: 10px;
  margin-bottom: 16px;
  letter-spacing: 2px;
  border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
}
.courseSummary{
  padding: 8px 8px 16px;
  font-size: 12px;
  text-align: right;
  color: #646464;
  border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
}

.teacherHolder img.t{
  width: 64px;
  height: 64px;
  margin-left: 8px;
  border-radius: 80px 0 80px 80px;
}

.question{
  font-size: 18px;
  font-weight: 300;
  margin-bottom: 16px;
  text-align: right;
}

.ltr {
  direction: ltr !important;
}

.rules{
  margin: 24px 24px 50px;
}

.ruleBox {
  padding: 0 8px;
}

.newExam h3, .examsList h3 {
  width: 100%;
  text-align: right;
  padding: 8px 16px;
  word-spacing: -2px;
  font-size: 20px;
  font-weight: 400;
}

.newExam h4, .examsList h4 {
  width: 100%;
  text-align: right;
  padding: 8px 16px;
  word-spacing: -2px;
  font-size: 14px;
  font-weight: 200;
  position: relative;
}

.newExam h4::before, .examsList h4::before{
  position: absolute;
  content: ' ';
  border-radius: 50%;
  width: 8px;
  height: 8px;
  background-color: royalblue;
  left: calc(100% - 8px);
  top: 50%;
  transform: translateY(-50%);
}

.newExam p, .examsList p {
  width: 100%;
  text-align: right;
  padding: 0px 16px;
  word-spacing: -1px;
  font-size: 12px;
  font-weight: 200;
  margin: 0 0 4px 0;
  position: relative;
}

.newExam p::before, .examsList p::before{
  position: absolute;
  content: ' ';
  border-radius: 50%;
  width: 8px;
  height: 8px;
  background-color: rgba(65, 105, 225, 0.301);
  left: calc(100% - 8px);
  top: 5px;
}

input[type="text"].f, input[type='number'].f {
  border-radius: 4px;
  border: solid 1px rgba($color: #000000, $alpha: 0.2);
  padding: 4px 8px;
  font-size: 13px;
  font-weight: 200;
  width: 100%;
}
// new game
.messageCenter {
  padding: 16px;
  i {
    font-size: 32px;
    color: $primary;
  }
  h3 {
    font-size: 22px;
    font-weight: bold;
    text-align: center;
    color: $primary;
  }
  span {
    font-size: 12px;
    color: $normalText;
  }
}

.inputHolder {
  margin-bottom: 4px;
  span {
    font-size: 12px;
    color: rgba($color: #888888, $alpha: 1.0);
    position: relative;
    i{
      color: $azadPrimary;
      font-size: 16px;
      margin-left: 8px;
    }
  }
  .inputWraper{
    position: relative;
    label{
      text-align: right;
      font-size: 12px;
      color: #888888;
    }
    input[type='number'], input[type='password'], input[type='text'], textarea{
      outline: none;
      -webkit-user-select: auto;
      -moz-user-select: auto;
      -ms-user-select: auto;
      user-select: auto;
      border: solid 2px rgba($color: $azadSecondary, $alpha: 0.25);
      padding: 3px 12px !important;
      text-align: right !important;
      margin: 8px 0px 8px 0 !important;
      font-size: 16px;
      font-weight: 300;
      letter-spacing: 0px;
      width: 100%;
      border-radius: 8px;
      color: $azadDarkText;
      resize: none;
      background-color: rgba(0, 0, 0, 0);
    }
    input[type='number']::placeholder,
    input[type='password']::placeholder,
    input[type='text']::placeholder,
    textarea::placeholder{
      font-weight: 100;
    }
    input[type='number']:disabled, input[type='password']:disabled, input[type='text']:disabled{
      font-size: 14px;
      opacity: 0.75;
    }
    textarea {
      max-height: 340px !important;
    }
  }
}

.addBox {
  padding: 16px;
  border-radius: 16px;
  border: solid 2px rgba($color: #000000, $alpha: 0.05);
  h2 {
    font-size: 16px;
    padding: 0;
    margin: 0 0 16px 0;
    i {
      color: rgba($color: #000000, $alpha: 0.25);
      margin-left: 8px;
    }
  }
}
</style>
